var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewChatIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1668 9.99987L17.1335 7.6832L17.4168 4.61654L14.4085 3.9332L12.8335 1.2832L10.0002 2.49987L7.16683 1.2832L5.59183 3.9332L2.5835 4.6082L2.86683 7.67487L0.833496 9.99987L2.86683 12.3165L2.5835 15.3915L5.59183 16.0749L7.16683 18.7249L10.0002 17.4999L12.8335 18.7165L14.4085 16.0665L17.4168 15.3832L17.1335 12.3165L19.1668 9.99987ZM15.4085 11.7582L15.6252 14.0832L13.3418 14.5999L12.1502 16.6082L10.0002 15.6832L7.85016 16.6082L6.6585 14.5999L4.37516 14.0832L4.59183 11.7499L3.05016 9.99987L4.59183 8.2332L4.37516 5.91654L6.6585 5.4082L7.85016 3.39987L10.0002 4.31654L12.1502 3.39154L13.3418 5.39987L15.6252 5.91654L15.4085 8.24154L16.9502 9.99987L15.4085 11.7582ZM9.16683 12.4999H10.8335V14.1665H9.16683V12.4999ZM9.16683 5.8332H10.8335V10.8332H9.16683V5.8332Z",
    fill: "#7F7F7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewChatIcon);
export default __webpack_public_path__ + "static/media/New-chat-icon.ed674950f58ddf7e48354c68ab8cc54a.svg";
export { ForwardRef as ReactComponent };